import React, { memo } from 'react';
import type { FC } from 'react';
import isEqual from 'lodash/isEqual';

import { ExtensionInsertUpsellLoader } from '@confluence/change-edition/entry-points/PremiumExtensionsUpsell';
import type { ExtensionSource } from '@confluence/change-edition/entry-points/PremiumExtensionsUpsell';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import type { EditorContextCustomSitesConfigPanelProps } from '../../shared-components/ContextPanel/EditorContextCustomSitesConfigPanel';
import { LazyEditorContextCustomSitesConfigPanel } from '../../shared-components/LazyEditorContextCustomSitesConfigPanel';

type EditorContextCustomSitesConfigPanelEntryPointProps = {
	upsellModalSource: ExtensionSource | undefined;
	setUpsellModalSource: (source: ExtensionSource | undefined) => void;
} & EditorContextCustomSitesConfigPanelProps;

export const EditorContextCustomSitesConfigPanelEntryPoint: FC<EditorContextCustomSitesConfigPanelEntryPointProps> =
	memo(({ localId, closeSelf, editorApi, contentId, upsellModalSource, setUpsellModalSource }) => {
		const isEnabled = useBooleanFeatureFlag('confluence.frontend.custom-sites.cards-extension');

		if (isEnabled) {
			if (upsellModalSource) {
				return (
					<ExtensionInsertUpsellLoader
						setUpsellModalSource={setUpsellModalSource}
						feature={upsellModalSource}
					/>
				);
			}

			if (localId) {
				return (
					<LazyEditorContextCustomSitesConfigPanel
						localId={localId}
						closeSelf={closeSelf}
						editorApi={editorApi}
						contentId={contentId}
					/>
				);
			}
		}

		return null;
	}, isEqual);
